import React, {useState} from "react";
let isValidInputs = true;

const WhitepaperForm = (props : any) => {
    const [fullName, setFullName] = useState("");
    const [fullNameErr, setFullNameErr] = useState(false);
    const [email, setEmail] = useState("");
    const [emailErr, setEmailErr] = useState(false);
    const [companyName, setCompanyName] = useState("");
    const [companyNameErr, setcompanyNameErr] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault()
        validateInputs()
        let hubspotFormId = props.post.acf_resources.hubspotFormId
        if(isValidInputs && hubspotFormId != null){
            var xhr = new XMLHttpRequest();
            var url = `https://api.hsforms.com/submissions/v3/integration/submit/25310090/${hubspotFormId}`;
            var data = {
                submittedAt: Date.now(),
                fields: [
                    {
                        name: "firstname",
                        value: fullName,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "company",
                        value: companyName,
                    },
                    {
                        name: "source_type",
                        value: 'whitepaper',
                    },
                ],
                "context": {
                    // "pageUri": post.link,
                    "pageName": props.post.seo.title
                },
            };
            var final_data = JSON.stringify(data);
            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    setFullName('')
                    setEmail('')
                    setCompanyName('')
                    setFormSuccess(true)
                    setTimeout(()=>{

                    },6000)
                    // Returns a 200 response if the submission is successful.
                } else if (xhr.readyState == 4 && xhr.status == 400) {

                } else if (xhr.readyState == 4 && xhr.status == 403) {

                }
            };
            xhr.send(final_data);
        }
    }
    const validateInputs = () => {

        // const emailRegEx = /^([\w-\.]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!yahoo.co.in)(?!aol.com)(?!abc.com)(?!xyz.com)(?!pqr.com)(?!rediffmail.com)(?!live.com)(?!outlook.com)(?!me.com)(?!msn.com)(?!ymail.com)([\w-]+\.)+[\w-]{2,4})?$/;
        const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        let emailId = email
        let isInvalidEmail = emailId.length < 2 || !emailRegEx.test(String(emailId).toLowerCase())
        let isInvalidFullName = fullName.length < 3
        let isInvalidCompanyName = companyName.length < 1

        if(isInvalidEmail){
            setEmailErr(true)
        }
        if(isInvalidFullName){
            setFullNameErr(true)
        }
        if(isInvalidCompanyName){
            setcompanyNameErr(true)
        }

        isValidInputs = !isInvalidEmail && !isInvalidFullName && !isInvalidCompanyName

        fetch(
            "https://app.middleware.io/api/v1/domain-verifier?email="+email)
            .then((res) => res.json())
            .then((json) => {
                if (json.disposable){
                    setEmailErr(true)
                }
            })

    }

    return <div className={'form'}>
        {!formSuccess && <form onSubmit={(e) => handleSubmit(e)}>
            <label>Full Name</label>
            <input type={'text'}
                   placeholder={'Full Name'}
                   value={fullName}
                   className={`${fullNameErr ? 'is-error' : ''}`}
                   onChange={(e) => {
                       const value = e.target && e.target.value
                       setFullName(value)
                   }}
                   onKeyUp={(e) => {
                       if (fullName.length > 0) {
                           setFullNameErr(false)
                       }
                   }}
            />
            <h6 className={`form-input-validation ${fullNameErr ? 'error' : ''}`}>Full name is required</h6>

            <label>Valid Email</label>
            <input type={'text'} placeholder={'Enter Email'}
                   className={`${emailErr ? 'is-error' : ''}`}
                   value={email}
                   onChange={(e) => {
                       const value = e.target && e.target.value
                       setEmail(value)
                   }}
                   onKeyUp={(e) => {
                       if (email.length > 0) {
                           setEmailErr(false)
                       }
                   }}
            />
            <h6 className={`form-input-validation ${emailErr ? 'error' : ''}`}>{email.length < 1 ? 'Email is required' : 'Invalid email'}</h6>

            <label>Company Name</label>
            <input type={'text'} placeholder={'Company Name'}
                   className={`${companyNameErr ? 'is-error' : ''}`}
                   value={companyName}
                   onChange={(e) => {
                       const value = e.target && e.target.value
                       setCompanyName(value)
                   }}
                   onKeyUp={(e) => {
                       if (companyName.length > 0) {
                           setcompanyNameErr(false)
                       }
                   }}
            />
            <h6 className={`form-input-validation ${companyNameErr ? 'error' : ''}`}>Company name is required</h6>
            <button className={'primary arrow'}>Read Whitepaper</button>
        </form>}
        {formSuccess && <div className={'form-submission download-asset-message'}>
            <h5>Thank You!</h5>

            <p>The whitepaper you requested is available for download below and also sent via email.</p>

            <a href={props.post?.acf_resources?.pdfUrl} target={'_blank'}>Download whitepaper</a>
        </div>}
    </div>
}

export default WhitepaperForm;